(() => {
  const languageOpen = document.querySelector(
    ".language-popup__switcher-button"
  );
  const languageClose = document.querySelector(".language-popup__close-button");
  const languagePopup = document.querySelector(".language-popup__wrapper");
  const languageInput = document.querySelector(".language-popup__search");
  const clearButton = document.querySelector(
    ".language-popup__search-wrapper .clear-button"
  );
  const regionName = document.querySelectorAll(".language-popup__region-name");
  const countryLinks = document.querySelectorAll(".country a");

  if (!languageOpen || !languagePopup) return;

  let lastFocusedElement = null;

  // Helper function to announce to screen readers
  function announceToScreenReader(message) {
    let liveRegion = document.getElementById("language-popup-live-region");

    if (!liveRegion) {
      liveRegion = document.createElement("div");
      liveRegion.id = "language-popup-live-region";
      liveRegion.setAttribute("role", "status");
      liveRegion.setAttribute("aria-live", "polite");
      liveRegion.setAttribute("aria-atomic", "true");
      liveRegion.className = "screen-reader-text";
      document.body.appendChild(liveRegion);
    }

    liveRegion.textContent = message;
  }

  // Trap focus within dialog
  let focusTrapHandler = null;
  const activateFocusTrap = () => {
    const getFocusableElements = () =>
      Array.from(
        languagePopup.querySelectorAll(
          'button:not([disabled]), [href]:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]):not([disabled])'
        )
      ).filter(el => el.offsetParent !== null);

    focusTrapHandler = e => {
      if (e.key !== "Tab") return;

      const focusableElements = getFocusableElements();

      if (focusableElements.length === 0) return;

      const firstFocusable = focusableElements[0];
      const lastFocusable = focusableElements[focusableElements.length - 1];

      if (e.shiftKey) {
        // Shift + Tab
        if (document.activeElement === firstFocusable) {
          e.preventDefault();
          lastFocusable.focus();
        }
      } else {
        // Tab
        if (document.activeElement === lastFocusable) {
          e.preventDefault();
          firstFocusable.focus();
        }
      }
    };

    document.addEventListener("keydown", focusTrapHandler);
  };

  const deactivateFocusTrap = () => {
    if (focusTrapHandler) {
      document.removeEventListener("keydown", focusTrapHandler);
      focusTrapHandler = null;
    }
  };

  // Open dialog with focus trap
  languageOpen.addEventListener("click", e => {
    e.preventDefault();
    lastFocusedElement = document.activeElement;
    languagePopup.showModal();
    languageOpen.setAttribute("aria-expanded", "true");

    // Activate focus trap
    activateFocusTrap();

    // Focus first element (search input)
    setTimeout(() => {
      languageInput.focus();
    }, 50);
  });

  // Close dialog and deactivate focus trap
  function closeDialog() {
    languagePopup.close();
    languageOpen.setAttribute("aria-expanded", "false");

    // Deactivate focus trap
    deactivateFocusTrap();

    // Return focus to button
    if (lastFocusedElement) {
      lastFocusedElement.focus();
    }

    // Clear search
    if (languageInput.value) {
      languageInput.value = "";
      languageInput.dispatchEvent(new Event("input"));
    }
  }

  languageClose.addEventListener("click", e => {
    e.preventDefault();
    closeDialog();
  });

  // Close on Escape key and focus close button on Ctrl+W
  languagePopup.addEventListener("keydown", e => {
    if (e.key === "Escape") {
      e.preventDefault();
      closeDialog();
    }

    // Focus close button with Ctrl+W or just X
    if ((e.ctrlKey && e.key === "w") || e.key === "x" || e.key === "X") {
      e.preventDefault();
      languageClose.focus();
    }
  });

  // Close on backdrop click
  languagePopup.addEventListener("click", e => {
    if (e.target === languagePopup) {
      closeDialog();
    }
  });

  // Search functionality
  languageInput.addEventListener("input", e => {
    const searchValue = e.target.value.toLowerCase();
    const languageItems = document.querySelectorAll(".country");
    const hasValue = searchValue.length > 0;

    // Show/hide clear button
    if (clearButton) {
      if (hasValue) {
        clearButton.removeAttribute("hidden");
      } else {
        clearButton.setAttribute("hidden", "");
      }
    }

    // Show/hide region names
    if (hasValue) {
      regionName.forEach(item => {
        item.classList.add("hidden");
      });
    } else {
      regionName.forEach(item => {
        item.classList.remove("hidden");
      });
    }

    // Filter countries
    languageItems.forEach(item => {
      const itemText = item.textContent.toLowerCase();

      if (itemText.includes(searchValue)) {
        item.classList.remove("hidden");
      } else {
        item.classList.add("hidden");
      }
    });

    // Announce results to screen readers
    const visibleCount = document.querySelectorAll(".country:not(.hidden)")
      .length;

    announceToScreenReader(`${visibleCount} wyników wyszukiwania`);
  });

  // Clear search
  if (clearButton) {
    clearButton.addEventListener("click", e => {
      e.preventDefault();
      languageInput.value = "";
      languageInput.dispatchEvent(new Event("input"));
      languageInput.focus();
    });
  }
})();
